module.exports = __webpack_public_path__ + "2ce624e8a0e2ac22675a2a1a7829c810.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/fuehrer_unclear.svg
// module id = 38
// module chunks = 0